export interface ConversationState {
  activityIdsToHide: string[];
}

export enum ConversationActionTypes {
  // TODO : Add dates when token is requested and when chat has received CONNECTION_FULLFILLED event
  APPEND_ACTIVITY_IDS_TO_HIDE = 'CONVERSATION/APPEND_ACTIVITY_IDS_TO_HIDE',
  RESET_STATE = 'CONVERSATION/RESET_STATE',
}
